import { render, staticRenderFns } from "./orderPayWaiting.vue?vue&type=template&id=26ebd1cf&scoped=true"
import script from "./orderPayWaiting.vue?vue&type=script&lang=js"
export * from "./orderPayWaiting.vue?vue&type=script&lang=js"
import style0 from "./orderPayWaiting.vue?vue&type=style&index=0&id=26ebd1cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ebd1cf",
  null
  
)

export default component.exports